export const setPoints = points => ({
  type: 'SET_POINTS',
  points,
});

export const login = user => ({
  type: 'LOGIN',
  user,
});
